// Converts a BDT amount to the "Taka: X (... taka and ... paisa only)" line
// required on Mushak forms — international (thousand/million) grouping,
// matching how NBR's own sample certificates spell it out.
const ONES = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
const TENS = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

function threeDigitsToWords(n: number): string {
  const parts: string[] = [];
  if (n >= 100) {
    parts.push(`${ONES[Math.floor(n / 100)]} hundred`);
    n %= 100;
  }
  if (n >= 20) {
    const tens = TENS[Math.floor(n / 10)];
    const ones = n % 10;
    parts.push(ones ? `${tens}-${ONES[ones]}` : tens);
  } else if (n > 0) {
    parts.push(ONES[n]);
  }
  return parts.join(' ');
}

function integerToWords(n: number): string {
  if (n === 0) return 'zero';
  const groups: [number, string][] = [
    [1_000_000_000, 'billion'],
    [1_000_000, 'million'],
    [1_000, 'thousand'],
    [1, ''],
  ];
  const parts: string[] = [];
  for (const [value, label] of groups) {
    if (n >= value) {
      const count = Math.floor(n / value);
      parts.push(label ? `${threeDigitsToWords(count)} ${label}` : threeDigitsToWords(count));
      n %= value;
    }
  }
  return parts.join(' ').trim();
}

function capitalize(s: string): string {
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
}

export function bdtAmountToWords(amount: number): string {
  const whole = Math.floor(Math.abs(amount));
  const paisa = Math.round((Math.abs(amount) - whole) * 100);
  const wholeWords = `${capitalize(integerToWords(whole))} taka`;
  if (paisa > 0) {
    return `${wholeWords} and ${integerToWords(paisa)} paisa only`;
  }
  return `${wholeWords} only`;
}

// Title-cases every word ("twenty-three thousand" -> "Twenty-Three
// Thousand"), including across a hyphen — matching how a quantity like
// "23 (Twenty-Three) Pieces" is conventionally spelled out on a Delivery
// Challan, as opposed to bdtAmountToWords' sentence-case "Twenty-three
// taka only".
export function quantityToWords(quantity: number): string {
  return integerToWords(Math.floor(Math.abs(quantity)))
    .split(' ')
    .map((word) => word.split('-').map(capitalize).join('-'))
    .join(' ');
}
